/* api.js */
const hdr = t => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${t}`,
});

export const fetchPreferences = token =>
  fetch('/mlapi/basic/user/preferences', { headers: hdr(token) }).then(r =>
    r.ok ? r.json() : Promise.reject(r)
  );

export const savePreferences = (token, prefs) =>
  fetch('/mlapi/basic/user/preferences', {
    method: 'POST',
    headers: hdr(token),
    body: JSON.stringify(prefs),
  });
